export async function useAudiences(vacancyType?: MaybeRef<VacancyType>) {
  const vacancyTypeRef = toRef(vacancyType)

  const allAudiences = useState<Audience[]>('allAudiences', () => [])

  if (!allAudiences.value || !allAudiences.value.length) {
    const { audiences } = await fetchAudiences()
    allAudiences.value = audiences.value ?? []
  }

  // Filtering
  // Currently, we're using a different set of activity types for activities.
  // Otherwise, return all activity types that don't have a vacancyType
  const typesToFilter = [VacancyType.Activity]
  const filteredAudiences = computed(() =>
    allAudiences.value.filter((audience) => {
      // Check if we're filtering on type
      if (vacancyTypeRef.value && typesToFilter.includes(vacancyTypeRef.value)) {
        return audience.vacancyType === vacancyTypeRef.value
      }
      // Ohterwise return all activity types that don't have a vacancyType
      return !audience.vacancyType
    }),
  )

  return {
    allAudiences,
    audiences: filteredAudiences,
  }
}
